module.exports = printJS;